<template>
  <div class="bar-chart-scroll">
    <div class="bar-chart-container">
      <canvas ref="canvas"></canvas>
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  name: 'C2wClicksByTitleBarChart',
  props: {
    campaigns: {
      type: Array,
      required: true,
    },
  },
  methods: {
    updateChart() {
      const counts = {};

      this.campaigns.forEach(c => {
        const title =
          c.headline || this.$t('C2W_CAMPAIGNS_REPORT.TABLE.NO_LABEL');
        counts[title] = (counts[title] || 0) + 1;
      });

      const labels = Object.keys(counts);
      const data = Object.values(counts);

      this.renderChart(
        {
          labels,
          datasets: [
            {
              label: this.$t('Total de clicks'),
              backgroundColor: '#42a5f5',
              data,
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                ticks: {
                  autoSkip: false,
                  callback: value =>
                    value.length > 12 ? value.slice(0, 12) + '…' : value,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        }
      );
    },
  },
  watch: {
    campaigns: {
      immediate: true,
      handler() {
        if (this.campaigns.length > 0) this.updateChart();
      },
    },
  },
  mounted() {
    this.updateChart();
  },
};
</script>

<style scoped>
.bar-chart-scroll {
  overflow-x: auto;
  width: 100%;
}

.bar-chart-container {
  position: relative;
  height: 300px;
  width: 100%;
  min-width: 0;
}
</style>
